
<template>
  <!--添加位置-->
  <div>
    <x-addEdit
      ref="addEdit"
      :initReqHandle="false"
      :formList="formList"
      :formKey="formKey"
      :addParam="addParam"
      :editParam="editParam"
      :detailParam="detailParam"
    >
      <template slot="gps" slot-scope="{formItem}">
        <x-location
          ref="location"
          :form="$refs.addEdit && $refs.addEdit.form"
          :inputKey="inputKey"
          :position="position"
          :lngLat="lngLat"
          :locationData="formItem">
        </x-location>
      </template>
    </x-addEdit>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'addLocation',
  data () {
    let decoratorOptions = {
      communityId: {
        rules: [{ required: true, message: '请选择小区' }]
      },
      positionName: {
        rules: [
          {required: true, message: '请输入位置名称'},
          { pattern: this.REG.name, message: '位置名称为2-20位汉字、字母、数字' }
        ]
      },
      categoryId: {
        rules: [{required: true, message: '请选择所属分类'}]
      },
      isStrictly: { rules: [] }
    };
    return {
      lngLat: [],
      position: '',
      inputKey: {
        lng: 'lng',
        lat: 'lat',
        address: 'no_address'
      },
      formList: [
        {
          label: '所属小区',
          inputType: 'select',
          options: [],
          handle: (e) => {
            this.communityChange(1, e, 'formList');
            this.$refs.addEdit.resetSubValue(['buildingId', 'unitId'], e);
            this.communitySelected(e);
          },
          placeholder: '请选择小区',
          fetchOptions: this.getOptions,
          props: ['communityId', decoratorOptions.communityId]
        },
        {
          label: '所属楼栋',
          inputType: 'select',
          options: [],
          handle: (e) => {
            this.buildingChange(2, e, 'formList');
            this.selectedBuilding(e);
          },
          placeholder: '请选择楼栋',
          props: ['buildingId', {
            rules: [{ required: false, message: '请选择楼栋' }]
          }]
        },
        {
          label: '所属单元',
          inputType: 'select',
          options: [],
          placeholder: '请选择单元',
          props: ['unitId',
            { rules: [{ required: false, message: '请选择单元' }] }
          ]
        },
        {
          label: '位置名称',
          inputType: 'input',
          options: [],
          placeholder: '请输入位置名称',
          props: ['positionName', decoratorOptions.positionName]
        },
        {
          label: '所属分类',
          inputType: 'cascader',
          options: [],
          placeholder: '请选择所属分类',
          handle: e => this.positionTypeChange(e),
          // fieldNames: {label: 'label', value: 'value', children: 'children'},
          props: ['categoryId', decoratorOptions.categoryId]
        },

        {
          slot: 'gps',
          label: 'GPS定位',
          inputType: 'input',
          subList: [
            {
              inputType: 'input',
              placeholder: '经度',
              props: ['lng', {
                validateTrigger: 'blur',
                rules: [{ required: true, message: '请定位经度' }]
              }]
            },
            {
              inputType: 'input',
              placeholder: '纬度',
              props: ['lat', {
                validateTrigger: 'blur',
                rules: [{ required: true, message: '请定位纬度' }]
              }]
            }
          ]
        },

        {
          label: '是否受限',
          inputType: 'checkboxGroup',
          options: [{ label: '', value: 1 }],
          placeholder: '',
          props: ['isStrictly', decoratorOptions.isStrictly]
        }
      ],
      formKey: {
        communityId: '',
        buildingId: '',
        unitId: '',
        positionName: '',
        categoryId: '',
        isStrictly: '',
        lng: '',
        lat: ''
      },
      addParam: {
        url: '/position',
        reqHandle: this.reqHandle, // this.reqHandle
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/position/',
        reqHandle: this.reqHandle,
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/position/',
        resHandle: this.detailResHandle
      }
    };
  },
  created () {
    this.setDisable();
    !this.$route.query.id && this.positionTypeChange(0);
    // this.communitySelect(0, 'formList', 1).then(() => {
    //   this.$route.query.id && this.$refs.addEdit.getDetail();
    // });
    this.communitySelectByStep(1, undefined, undefined, '0').then(() => {
      this.$route.query.id && this.$refs.addEdit.getDetail();
    });
    this.dictionarySelect([{index: 4, scope: 'formList', query: 'comu_position_type'}]);
  },
  mounted () {
  },
  methods: {
    getOptions (pageNum, search, item) {
      return this.communitySelectByStep(pageNum, search, undefined, 0, item.communityId);
    },
    setDisable () {
      let canDelete = this.$route.query.canDelete;
      if (canDelete === 0 || canDelete === '0') {
        let propArr = ['communityId', 'buildingId', 'unitId'];
        this.formList.forEach((item) => {
          let hasProp = propArr.some(el => el === (item.props && item.props[0]));
          if (hasProp) {
            item.disabled = true;
          }
        });
      }
    },
    /** 选择所属分类 change 事件 */
    positionTypeChange (e) {
      e = Array.isArray(e) ? e[0] : e;
      this.formList.forEach((el) => {
        if (el.slot && el.slot === 'gps') {
          e === '6' ? el.isShow = true : el.isShow = false;
        }
      });
    },
    /** 通过小区的省市区来获取经纬度 */
    communitySelected (val) {
      this.formList[1].props[1].rules[0].required = false;
      this.formList[2].props[1].rules[0].required = false;
      this.setLocation(val);
    },
    /** 设置 gps定位 position 变量 */
    setLocation (val) {
      if (!val) { return; }
      this.$refs.location && (this.$refs.location.positionChanged());
      let label = this.formList[0].options.filter(ele => ele.value === val);
      let labelArr = label[0] && label[0].label.split('/')[0].split(' ');
      let isCity = labelArr && this.$store.state.citys.some(el => el === labelArr[0]);
      isCity ? this.position = labelArr[0] : this.position = labelArr && labelArr[1] || '';
    },
    /* 选择所属楼栋 */
    selectedBuilding (e) {
      this.formList.forEach((el) => {
        let props = el.props;
        if (props && props[0] === 'unitId') {
          let unitId = props[1].rules[0];
          e ? unitId.required = true : unitId.required = false;
          this.$refs.addEdit.resetSubValue(['unitId'], e);
        }
      });
    },
    detailResHandle (data) {
      if (data.categoryId) {
        data.categoryId = [data.categoryId];
        this.positionTypeChange(data.categoryId);
      }
      let formValues = {};
      for (let item in data) {
        if (this.formKey.hasOwnProperty(item)) {
          formValues[item] = data[item];
        }
      }

      let keyArr = ['buildingId', 'unitId'];
      keyArr.forEach((el) => {
        if (data.hasOwnProperty(el) && data[el]) {
          formValues[el] = data[el];
        } else {
          formValues[el] = '';
        }
      });

      this.formList.forEach((el) => {
        if (el.props && el.props[0] === 'unitId') {
          let rule = el.props[1].rules[0];
          data.buildingId ? rule.required = true : rule.required = false;
        }
      });

      if (data.isStrictly) {
        formValues.isStrictly = [data.isStrictly];
      } else {
        formValues.isStrictly = [];
      }
      let buildingId = data.buildingId;
      let communityId = data.communityId;
      let loadCascadeOptions = () => {
        this.communityChange(1, communityId, 'formList');
        this.setLocation(communityId);
        if (buildingId) { // 根据小区id楼栋id获取单元列表
          this.buildingChange(2, buildingId, 'formList');
        }
      };

      this.formList[0].communityId = communityId;
      if (data.communityId) { // 根据小区id获取楼栋列表
        let arr = this.formList[0].options;
        let isExit = arr.some(item => item.value == data.communityId);
        if (!isExit) {
          this.$get({
            url: '/community/treeselect/page',
            params: {communityId: data.communityId}
          }).then(({data: communityData}) => {
            if (communityData.rows && communityData.rows[0]) {
              arr.unshift(communityData.rows[0]);
            }
            loadCascadeOptions();
          });
        } else {
          loadCascadeOptions();
        }
      }

      if (data.lng && data.lat) {
        let lng = parseFloat(data.lng);
        let lat = parseFloat(data.lat);
        lng !== 0 && lat !== 0 && (this.lngLat = [lng, lat]);
      }

      this.$nextTick(() => {
        this.$refs.addEdit.form.setFieldsValue(formValues);
      });
    },
    reqHandle (param) {
      param.categoryId = param.categoryId.join(',');
      param.isStrictly = ((param.isStrictly && param.isStrictly.length) ? param.isStrictly.join(',') : '0');
      return param;
    },
    addResHandle (res) {
      return res;
    },
    editResHandle (res) {
      return res;
    }
  }
};
</script>
